import React from 'react';
import { connect } from 'react-redux';
import { IDispatchProp } from 'restdux';
import {
    Card,
    CardActions,
    CardContent,
    Input,
    Theme,
    withTheme, 
    WithTheme, 
    Typography,
    Grid,
    Button,
} from '@material-ui/core';
import { createStyles, withStyles, WithStyles } from '@material-ui/styles';
import { IReturn as LivescanVendor, actions as lsvActions } from '../../../api/resources/LivescanVendor';
import { Formik, Form, Field } from 'formik';
import { TextField } from 'formik-material-ui';
import * as Yup from 'yup';


const styles = (theme: Theme) =>
    createStyles({
        content: {
            padding: '8px 16px',
        },
        itemActions: {
            display: 'flex',
            justifyContent: 'flex-end',
        },
        metaData: {
            marginTop: 12,
        },  
    });

interface IProps {
    lsv: LivescanVendor;
};

interface IState {
    editing: boolean;
}

const FormSchema = Yup.object().shape({
	contact_first_name: Yup.string().required(),
    contact_last_name: Yup.string().required(),
    contact_email: Yup.string().email().required(),
    contact_phone: Yup.string().required()
});

type FullProps = IProps & WithStyles<typeof styles> & WithTheme & IDispatchProp;
class ProfileSummaryCard extends React.PureComponent<FullProps, IState> {
    public state = {
        editing: false,
    }
    
    render() {
        const { lsv, classes } = this.props;
        const { editing } = this.state;

        return (
            <Card>
                {editing ? (
                    <Formik
                        initialValues={{
                            contact_first_name: lsv.contact_first_name,
                            contact_last_name: lsv.contact_last_name,
                            contact_email: lsv.contact_email,
                            contact_phone: lsv.contact_phone,
                        }}
                        validationSchema={FormSchema}
                        onSubmit={(values, {setSubmitting}) => {
                            this.onSave(values);
                        }}
                    >
                    {({ submitForm, isSubmitting }) => (
                        <Form>
                            <CardContent>
                                <Grid container spacing={2} className={classes.metaData}>
                                    <Grid item sm={6} xs={12}>
                                        <Grid container spacing={1}>
                                            <Grid item xs={6}>
                                                <Typography variant="subtitle2">First Name</Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Field component={TextField} name="contact_first_name" fullWidth required autoFocus />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Typography variant="subtitle2">Last Name</Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Field component={TextField} name="contact_last_name" fullWidth required />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item sm={6} xs={12}>
                                        <Grid container spacing={1}>
                                            <Grid item xs={6}>
                                                <Typography variant="subtitle2">Email</Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Field component={TextField} name="contact_email" fullWidth required />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Typography variant="subtitle2">Phone</Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Field component={TextField} name="contact_phone" fullWidth required />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </CardContent>
                            <CardActions>
                                <Button color="primary" onClick={submitForm}>Save</Button>
                                <Button onClick={this.onCancel}>Cancel</Button>
                            </CardActions>
                        </Form>
                    )}
                    </Formik>
                ) : (
                    <>
                        <CardContent>
                            <Grid container spacing={2} className={classes.metaData}>
                                <Grid item sm={6} xs={12}>
                                    <Grid container spacing={1}>
                                        <Grid item xs={6}>
                                            <Typography variant="subtitle2">First Name</Typography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Typography variant="body2">{lsv.contact_first_name}</Typography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Typography variant="subtitle2">Last Name</Typography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Typography variant="body2">{lsv.contact_last_name}</Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item sm={6} xs={12}>
                                    <Grid container spacing={1}>
                                        <Grid item xs={6}>
                                            <Typography variant="subtitle2">Email</Typography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Typography variant="body2">{lsv.contact_email}</Typography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Typography variant="subtitle2">Phone</Typography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Typography variant="body2">{lsv.contact_phone}</Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </CardContent>
                        <CardActions>
                            <Button color="primary" onClick={this.onModify}>Modify</Button>
                        </CardActions>
                    </>
                )}
                
                
            </Card>
        )
    }

    public onModify = () => {
        this.setState({editing: true});
    };

    public onSave = (values: Partial<LivescanVendor>) => {
        const { lsv, dispatch } = this.props;
        
        dispatch(lsvActions.update(lsv.id, values));

        this.setState({editing: false});
    }

    public onCancel = () => {
        this.setState({editing: false});
    }
}

export default connect()(withTheme(withStyles(styles)(ProfileSummaryCard)));